import React from 'react';
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Box,
} from '@material-ui/core';
import GetStartedBtn from 'components/ListYourBike/GetStartedBtn';
import Image from 'next/image';
import readyToEarn from '../../public/imgs/list-your-bike/ready_to_earn.svg';
import bluer from '../../public/imgs/1x1.png';

const useStyles = makeStyles((theme) => ({
  greyBG: {
    backgroundColor: theme.palette.grey.A000,
    [theme.breakpoints.only('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  mainContainer: {
    marginTop: theme.spacing(8.125),
    marginBottom: theme.spacing(13),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(12.5),
      marginBottom: theme.spacing(6.25),
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(3.75),
      marginBottom: theme.spacing(6.5),
    },
  },
  imgGrid: {
    [theme.breakpoints.up('lg')]: {
      order: 2,
    },
  },
  txtGrid: {
    [theme.breakpoints.up('lg')]: {
      order: 1,
      paddingLeft: `${theme.spacing(5.75)} !important`,
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(40),
      fontWeight: '500',
      marginBottom: theme.spacing(4.5),
    },
    [theme.breakpoints.up('lg')]: {
      textAlign: 'left',
      marginBottom: theme.spacing(2.75),
      marginTop: theme.spacing(-8.75),
    },
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '500',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(22),
    },
    [theme.breakpoints.up('lg')]: {
      textAlign: 'left',
    },
  },
  getStartedBox: {
    marginTop: theme.spacing(4.5),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(6.25),
    },
    [theme.breakpoints.up('lg')]: {
      textAlign: 'left',
      marginTop: theme.spacing(5),
    },
  },
  imgContainer: {
    textAlign: 'center',
    marginBottom: theme.spacing(6.25),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(9),
    },
  },
  img: {
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '85%',
    },
  },
}));

const ReadyToEarn = ({ i18n }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.greyBG}>
        <Container maxWidth="xl" classes={{ root: classes.mainContainer }}>
          <Grid container justify="center" alignItems="center" spacing={2}>
            <Grid item xs={12} lg={6} classes={{ item: classes.imgGrid }}>
              <Box className={classes.imgContainer}>

                <Image
                  className={classes.img}
                  src={readyToEarn.src}
                  // src="imgs/list-your-bike/ready_to_earn.svg"
                  alt={i18n('fe_list_your_bike:ready_to_earn')}
                  width="530"
                  height="370"
                  unoptimized
                  placeholder="blur"
                  blurDataURL={bluer.src}
                />
              </Box>
            </Grid>
            <Grid item xs={12} lg={6} classes={{ item: classes.txtGrid }}>
              <Typography variant="h2" classes={{ root: classes.title }}>
                {i18n('fe_list_your_bike:ready_to_earn')}
              </Typography>
              <Typography variant="h3" classes={{ root: classes.subTitle }}>
                {i18n('fe_list_your_bike:join_community')}
              </Typography>
              <Box className={classes.getStartedBox}>
                <GetStartedBtn i18n={i18n} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ReadyToEarn;
